<template>
  <div
    class="form-chips control-group"
    :class="{ error: error }"
  >
    <label class="control-label form-chips__label">
      {{ label }}
    </label>
    <wp-chips
      :value="joinedValue"
      name="form-chips"
      @input="v => $emit('input', JSON.parse(v))"
    />
    <span
      v-if="error && error.input"
      class="help-inline"
    >
      {{ error.input }}
    </span>
  </div>
</template>

<script>
import WpChips from '../chips.vue';

export default {
  name: 'FormChips',

  schema: [
    {
      name: 'label',
      default: 'default',
      type: 'FormText',
      label: 'Label',
    },
  ],

  components: {
    WpChips,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      required: true,
    },
    error: {
      type: Object,
      default: () => (null),
    },
  },

  computed: {
    joinedValue() {
      return JSON.stringify(this.value);
    },
  },
};
</script>

<style lang="scss">
.form-chips {
  display: flex;
  flex-grow: 1;

  &__label.control-label {
    flex: 0 0 500px;
    font-size: 14px;
    line-height: 30px;
    margin-right: 20px;
    padding-left: 40px;
    text-align: left;
  }
}
</style>
